import React, { useContext } from 'react';
import { Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/CopyAllSharp';
import { SettingsContext } from '../../contexts/SettingsContext';

interface ShareButtonProps {
    onClick: () => void;
}

const ShareButton: React.FC<ShareButtonProps> = ({ onClick }) => {
    const { settings } = useContext(SettingsContext);

    return (
        <Button
            variant="contained"
            startIcon={<ShareIcon />}
            onClick={onClick}
            sx={{
                backgroundColor: settings.backgroundColor,
                color: settings.textColor,
                '&:hover': {
                    backgroundColor: settings.backgroundColor,
                },
            }}
        >
            Share
        </Button>
    );
};

export default ShareButton;